import { render, staticRenderFns } from "./LogoutComponent.vue?vue&type=template&id=113f91ee&scoped=true&"
import script from "./LogoutComponent.vue?vue&type=script&lang=js&"
export * from "./LogoutComponent.vue?vue&type=script&lang=js&"
import style0 from "./LogoutComponent.vue?vue&type=style&index=0&id=113f91ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f91ee",
  null
  
)

export default component.exports